export default `return mat2( cos( r ), sin( r ), -sin( r ), cos( r ) );
}
float de(vec3 p){
  float e, s=.5;
  for(e=++p.y;s>.005;s*=.77)
    p.x=abs(p.x),
    e=min(e,max(abs(p.y-s*.5)-s*.4,
    length(p.xz))-s*.2),
    p.y-=s,
    p.xz*=rotate2D(1.57),
    p.zy*=rotate2D(.5);
  return e;
}`